// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DTADetailsSourceDocument
 */
export interface DTADetailsSourceDocument {
    /**
     * 
     * @type {string}
     * @memberof DTADetailsSourceDocument
     */
    content_type?: string;
    /**
     * 
     * @type {string}
     * @memberof DTADetailsSourceDocument
     */
    filename?: string;
    /**
     * 
     * @type {string}
     * @memberof DTADetailsSourceDocument
     */
    s3_bucket?: string;
    /**
     * 
     * @type {string}
     * @memberof DTADetailsSourceDocument
     */
    s3_key?: string;
    /**
     * 
     * @type {string}
     * @memberof DTADetailsSourceDocument
     */
    uploaded_at?: string;
}

/**
 * Check if a given object implements the DTADetailsSourceDocument interface.
 */
export function instanceOfDTADetailsSourceDocument(value: object): value is DTADetailsSourceDocument {
    return true;
}

export function DTADetailsSourceDocumentFromJSON(json: any): DTADetailsSourceDocument {
    return DTADetailsSourceDocumentFromJSONTyped(json, false);
}

export function DTADetailsSourceDocumentFromJSONTyped(json: any, ignoreDiscriminator: boolean): DTADetailsSourceDocument {
    if (json == null) {
        return json;
    }
    return {
        
        'content_type': json['content_type'] == null ? undefined : json['content_type'],
        'filename': json['filename'] == null ? undefined : json['filename'],
        's3_bucket': json['s3_bucket'] == null ? undefined : json['s3_bucket'],
        's3_key': json['s3_key'] == null ? undefined : json['s3_key'],
        'uploaded_at': json['uploaded_at'] == null ? undefined : json['uploaded_at'],
    };
}

export function DTADetailsSourceDocumentToJSON(json: any): DTADetailsSourceDocument {
    return DTADetailsSourceDocumentToJSONTyped(json, false);
}

export function DTADetailsSourceDocumentToJSONTyped(value?: DTADetailsSourceDocument | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'content_type': value['content_type'],
        'filename': value['filename'],
        's3_bucket': value['s3_bucket'],
        's3_key': value['s3_key'],
        'uploaded_at': value['uploaded_at'],
    };
}
